import { http } from "./config.api.js"
// 签章相关 secSeal

export const seal = (controllName, method, params) => { return http.post("/" + controllName + "/" + method, params).then(res => res.data) };

export const getList = (pageInfo, params) => { return http.get("/secSealFileCurrent/secSealFileCurrents/" + pageInfo, { urlParams: params }).then(res => res.data); };

// API_SecSeal.deletePdf({ data:{code:"SGXMKP001",tableName:"hy_safety_unitselfeval",rpx:"safetyunitselfeval"}}).then(res=>{
// 	this.$refs.selfDialog.loading = false;
// 	this.showFormBtns = true;
// })
export const deletePdf = (params) => { return http.delete("/secSealFileCurrent/deleteCreatedPdfFile", { urlParams: params }).then(res => res.data); };

export const getFileByPost = (pageInfo, params) => { return http.post("/secSealFileCurrent/getAttachFileInfos/" + pageInfo, params).then(res => res.data); };


// WEBPACK FOOTER //
// ./src/api/api_secSeal.js